import * as React from 'react';

import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { IsValidUrl } from '../../utils/helpers/url';

import { Line } from '../ui/divider/Line';
import { HeaderSpace } from './HeaderBottomCard';

export const ServicesStyle = styled((props: any) => <Link {...props} />) <any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 35px;
  text-align: center !important;
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;
  h4 {
    font-size: 25px;
    color: ${({ theme }) => theme.colors.primary};
  }
  p {
    width: 100%;
    max-width: 16em;
  }
`;

export const Services: React.FC<{
  title?: string;
  hidedivider?: boolean;
  text?: string;
  link?: string;
}> = ({ link, title, text, hidedivider }) => {
  const [external] = React.useState(IsValidUrl(link));

  const content = () => {
    return (
      <>
        <h4>{title}</h4>
        {!hidedivider ? <Line /> : null}
        <HeaderSpace>
          {text ? <p dangerouslySetInnerHTML={{ __html: text }}></p> : null}
        </HeaderSpace>
      </>
    );
  };

  if (external) {
    return (
      <ServicesStyle href={link} as={'a'}>
        {content()}
      </ServicesStyle>
    );
  } else {
    return <ServicesStyle to={link}>{content()}</ServicesStyle>;
  }
};
